import React, { forwardRef } from "react";
import Spinner from "../Spinner";

const InputDropdown = forwardRef(
  ({
    id,
    placeholder,
    label,
    forr,
    InputDropdownRef,
    props,
    onChange,
    onBlur,
    inputDropdownOptions,
    defaultOptionName,
    defaultValue,
    optionKey,
    valueWithId,
    setValue,
    value,
    loading,
  }) => {
    return (
      <div className="form-floating">
        <div
          style={{
            position: "absolute",
            top: "10px",
            width: "100%",
            right: "30px",
          }}
        >
          {loading && <Spinner className="text-center" />}
        </div>
        <select
          className="form-select"
          id={id}
          placeholder={placeholder}
          ref={InputDropdownRef}
          {...props}
          onChange={onChange}
          onBlur={onBlur}
          defaultValue={defaultValue}
          value={value}
        >
          <option value={defaultValue || ""} disabled hidden>
            {defaultOptionName || defaultValue}
          </option>
          {inputDropdownOptions?.map(({ option }, index) => (
            <option
              key={index}
              value={
                optionKey
                  ? inputDropdownOptions[index].id
                  : valueWithId
                  ? inputDropdownOptions[index].id
                  : option
              }
            >
              {optionKey ? inputDropdownOptions[index][optionKey] : option}
            </option>
          ))}
        </select>
        <label for={forr}>{label}</label>
      </div>
    );
  }
);

export default InputDropdown;
